/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuditEvent
 */
export interface AuditEvent {
    /**
     * The audit event unique identifier.
     * @type {string}
     * @memberof AuditEvent
     */
    auditEventId: string;
    /**
     * The organization's unique identifier.
     * @type {string}
     * @memberof AuditEvent
     */
    organizationId: string;
    /**
     * The workspace unique identifier.
     * @type {string}
     * @memberof AuditEvent
     */
    workspaceId: string;
    /**
     * The email address of the user whose action created the audit event.
     * @type {string}
     * @memberof AuditEvent
     */
    email: string;
    /**
     * The category of audit event.
     * @type {string}
     * @memberof AuditEvent
     */
    category?: string;
    /**
     * A description of the audit event.
     * @type {string}
     * @memberof AuditEvent
     */
    description: string;
    /**
     * The timestamp that the audit event record was created.
     * @type {Date}
     * @memberof AuditEvent
     */
    timestamp: Date;
}

export function AuditEventFromJSON(json: any): AuditEvent {
    return AuditEventFromJSONTyped(json, false);
}

export function AuditEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'auditEventId': json['auditEventId'],
        'organizationId': json['organizationId'],
        'workspaceId': json['workspaceId'],
        'email': json['email'],
        'category': !exists(json, 'category') ? undefined : json['category'],
        'description': json['description'],
        'timestamp': (new Date(json['timestamp'])),
    };
}

export function AuditEventToJSON(value?: AuditEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'auditEventId': value.auditEventId,
        'organizationId': value.organizationId,
        'workspaceId': value.workspaceId,
        'email': value.email,
        'category': value.category,
        'description': value.description,
        'timestamp': (value.timestamp.toISOString()),
    };
}


